@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        @if (!field?.settings?.format || field?.settings?.format === PicklistFormat.DropDownList) {
          <div
            class="select is-secondary is-medium">
            <select [(ngModel)]="value">
              <option [value]=""></option>
              @for (picklistValue of picklistValues; track picklistValue.uId) {
                <option
                  [value]="picklistValue.uId">
                  {{ picklistValue.value }}
                </option>
              }
            </select>
          </div>
        }
        @if (field?.settings?.format === PicklistFormat.CheckBox) {
          <div
            class="checkbox-list">
            @for (picklistValue of picklistValues; track picklistValue.uId) {
              <div
                class="mb-2">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    [value]="picklistValue.uId"
                    [name]="field.systemName"
                    [checked]="value === picklistValue.uId"
                    (change)="checkChange($event)"
                    class="mr-3" />
                  {{ picklistValue.value }}
                </label>
              </div>
            }
          </div>
        }
        @if (field?.settings?.format === PicklistFormat.Radio) {
          <div
            class="radio-list">
            @for (picklistValue of picklistValues; track picklistValue.uId) {
              <div>
                <label class="radio">
                  <input
                    type="radio"
                    [value]="picklistValue.uId"
                    [name]="field.systemName"
                    [checked]="value === picklistValue.uId"
                    (change)="checkChange($event)" />
                  {{ picklistValue.value }}
                </label>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="is-readonly">
        {{ selectedValue }}
      </div>
    }
  </div>
}
